import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, switchMap } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import { REFETCH_APP_DATA_ACTIONS } from 'containers/App/constants'
import { UPDATE_USER_REQUEST_ASYNC } from 'containers/Settings/Users/constants'

import { selectCompaniesData, selectPartner, selectSelfCompanyId } from '../App/selectors'

import { fetchSelectedCompanyDataError, fetchSelectedCompanyDataSuccess } from './actions'
import { COMPANY_FILTER_APPLY, COMPANY_FILTER_CHANGE } from './constants'
import { selectCompanyFilter } from './selectors'

const fetchSelectedCompanyDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(COMPANY_FILTER_CHANGE, UPDATE_USER_REQUEST_ASYNC.SUCCESS, ...REFETCH_APP_DATA_ACTIONS),
    filter(() => !!selectPartner(state$.value)),
    switchMap((action) => {
      const state = state$.value

      const selfCompanyId = selectSelfCompanyId(state)
      const selectedCompanyId = selectCompanyFilter(state)?.value
      const isDataExist = selectCompaniesData(state).find((c) => c.id === selectedCompanyId)

      if (
        action.type === COMPANY_FILTER_CHANGE &&
        (selfCompanyId === selectedCompanyId || isDataExist)
      ) {
        return of(fetchSelectedCompanyDataSuccess(null))
      } else {
        return api.msp.getCompanyData(selectedCompanyId).pipe(
          map((response) => fetchSelectedCompanyDataSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchSelectedCompanyDataError, error)))
        )
      }
    })
  )

const changeSelectedCompanyEpic = (action$) =>
  action$.pipe(
    ofType(COMPANY_FILTER_APPLY, COMPANY_FILTER_CHANGE),
    mergeMap((action) => {
      if (typeof window.dataLayer?.push === 'function') {
        // Google Tag Manager
        window.dataLayer.push({
          selectedCompanyId: action.payload.selectedCompany.value,
        })
      }
      return of(() => {})
    })
  )

export default combineEpicsIsolated(fetchSelectedCompanyDataEpic, changeSelectedCompanyEpic)
